import { render, staticRenderFns } from "./ScoutExcluded.vue?vue&type=template&id=dd1a35bc"
import script from "./ScoutExcluded.vue?vue&type=script&lang=js"
export * from "./ScoutExcluded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports